import { z } from '@harvestiq/zod';
import {
  dbClaimEventInsertSchema,
  dbClaimEventSchema,
} from './db-claim-events';

export const createClaimEventReqBodySchema = dbClaimEventInsertSchema.pick({
  claimId: true,
  status: true,
  eventType: true,
});
export type CreateClaimEventReqBody = z.infer<
  typeof createClaimEventReqBodySchema
>;

export const createClaimEventResponseSchema = z.object({
  claimEvent: dbClaimEventSchema.optional(),
  error: z.string().optional(),
});
export type CreateClaimEventResponse = z.infer<
  typeof createClaimEventResponseSchema
>;
